import { Box, Button, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import { cityBranchColumns, pdfheader, pdfSubHeader, jsPdfHeaderFooter, pdffilterHeader, cityBranchData, cityBranchColumnsStyles, updateCityBranchData } from './constants'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import * as id from '../reportId'
import AppsIcon from '@mui/icons-material/Apps'
import * as mdt from '../../../common/modaltypes'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, generateDynamicColumnStyles } from '../../../common/helper'
import useToken from '../../../helpers/useTokens'
import { SAINI_TRAVELS } from '../../../../helper/companyIdhardcode'

const QuickViewCitywiseBranchwise = ({ disableExcel, headerData, tableData, updateModal, tableHeader, selectedFields,UseToPayAsCOD }) => {

  const { loginData } = useToken()
  const {intCompanyID} = loginData
  const [searchResult, setSearchResult] = useState(true)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load, } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const InsideRowContent = ({ item, index,UseToPayAsCOD }) => {
    return (
      <>
        <TableRow>
          {
            item.isTotal ?
              <>
                <TableCell className="reportTD" colSpan={2} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'left', borderRight: "1px solid #e0e0e0" }}>{item.CityName} </TableCell>

                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedPaid} </TableCell>


                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedToPay} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedFOC} </TableCell>
                {UseToPayAsCOD!==1&&<TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedCOD} </TableCell>}
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedOnAccount} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedToPayDDDV} </TableCell>
                {selectedFields.hasOwnProperty('BookedFreight') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedFreight} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedDocumentCharges') &&

                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedDocumentCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedHamaliCharges') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedHamaliCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOperatorHamaliChg') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedOperatorHamaliChg} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOtherCharges') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedOtherCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedGST') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.BookedGST} </TableCell>
                }
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right', borderRight: "1px solid #e0e0e0" }}>{item.TotalBoookedPayment} </TableCell>
                {SAINI_TRAVELS===intCompanyID?<></>:
                <>
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredPaid} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredToPay} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredFOC} </TableCell>
                {UseToPayAsCOD!==1&&<TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredCOD} </TableCell>}
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredOnAccount} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredToPayDDDV} </TableCell>
                {selectedFields.hasOwnProperty('DeliveredHamali') &&

                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredHamali} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveryOtherHamali') &&

                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveryOtherHamali} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredInsurance') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredInsurance} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredOtherCharges') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredOtherCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredGST') &&
                  <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredGST} </TableCell>
                }
                <TableCell className="reportTD" colSpan={1} style={{ color: "#444444", background: '#eeeeee', height: "36px", fontSize: '12px', fontWeight: '600', textAlign: 'right' }}>{item.TotalDeliveredPayment} </TableCell>
                </>}
              </>
              :
              <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  title={item.CityName}
                  style={{ cursor: "pointer", color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'left', minWidth: "100px", maxWidth: "100px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}
                >
                  {item.CityName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  title={item.BranchName}
                  style={{ cursor: "pointer", color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'left', minWidth: "150px", maxWidth: "150px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', borderRight: "1px solid #e0e0e0" }}
                >
                  {item.BranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedPaid}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedToPay}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedFOC}
                </TableCell>
                {UseToPayAsCOD!==1&&<TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedCOD}
                </TableCell>}
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedOnAccount}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedToPayDDDV}
                </TableCell>
                {selectedFields.hasOwnProperty('BookedFreight') &&

                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedFreight}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedDocumentCharges') &&

                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedDocumentCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedHamaliCharges') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedHamaliCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOperatorHamaliChg') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedOperatorHamaliChg}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOtherCharges') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedOtherCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedGST') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedGST}
                  </TableCell>
                }
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right', borderRight: "1px solid #e0e0e0" }}
                >
                  {item.TotalBoookedPayment}
                </TableCell>
                {SAINI_TRAVELS===intCompanyID?<></>:
                <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredPaid}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredToPay}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredFOC}
                </TableCell>
                {UseToPayAsCOD!==1&&<TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredCOD}
                </TableCell>}
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredOnAccount}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredToPayDDDV}
                </TableCell>
                {selectedFields.hasOwnProperty('DeliveredHamali') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredHamali}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveryOtherHamali') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryOtherHamali}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredInsurance') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredInsurance}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredOtherCharges') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredOtherCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredGST') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredGST}
                  </TableCell>
                }
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ color: "#444444", fontSize: '12px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.TotalDeliveredPayment}
                </TableCell>
                </>
                }
              </>
          }
        </TableRow>
      </>
    )
  }
  const InsideRowContentForExcel = ({ item, index ,UseToPayAsCOD}) => {
    return (
      <>
        <TableRow>
          {
            item.isTotal ?
              <>
                <TableCell className="reportTD" colSpan={2} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}>{item.CityName} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedPaid} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedToPay} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedFOC} </TableCell>
                {UseToPayAsCOD!==1&&<TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedCOD} </TableCell>}
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedOnAccount} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedToPayDDDV} </TableCell>
                {selectedFields.hasOwnProperty('BookedFreight') &&

                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedFreight} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedDocumentCharges') &&

                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedDocumentCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedHamaliCharges') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedHamaliCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOperatorHamaliChg') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedOperatorHamaliChg} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOtherCharges') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedOtherCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedGST') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.BookedGST} </TableCell>
                }
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.TotalBoookedPayment} </TableCell>
                {SAINI_TRAVELS===intCompanyID?<></>:
                <>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredPaid} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredToPay} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredFOC} </TableCell>
                {UseToPayAsCOD!==1&&<TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredCOD} </TableCell>}
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredOnAccount} </TableCell>
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredToPayDDDV} </TableCell>
                {selectedFields.hasOwnProperty('DeliveredHamali') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredHamali} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveryOtherHamali') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveryOtherHamali} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredInsurance') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredInsurance} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredOtherCharges') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredOtherCharges} </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredGST') &&
                  <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.DeliveredGST} </TableCell>
                }
                <TableCell className="reportTD" colSpan={1} style={{ background: '#eeeeee', height: "36px", fontSize: '20px', fontWeight: '600', textAlign: 'right' }}>{item.TotalDeliveredPayment} </TableCell>
                </>}
              </>
              :
              <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  title={item.CityName}
                  style={{ cursor: "pointer", fontSize: '20px', fontWeight: '500', textAlign: 'left', }}
                >
                  {item.CityName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  title={item.BranchName}
                  style={{ cursor: "pointer", fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                >
                  {item.BranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedPaid}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedToPay}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedFOC}
                </TableCell>
                {UseToPayAsCOD!==1&&<TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedCOD}
                </TableCell>}
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedOnAccount}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.BookedToPayDDDV}
                </TableCell>
                {selectedFields.hasOwnProperty('BookedFreight') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedFreight}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedDocumentCharges') &&

                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedDocumentCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedHamaliCharges') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedHamaliCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOperatorHamaliChg') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedOperatorHamaliChg}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedOtherCharges') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedOtherCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('BookedGST') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BookedGST}
                  </TableCell>
                }
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right', borderRight: "1px solid #c1c1c1" }}
                >
                  {item.TotalBoookedPayment}
                </TableCell>
                {SAINI_TRAVELS===intCompanyID?<></>:
                <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredPaid}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredToPay}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredFOC}
                </TableCell>
                {UseToPayAsCOD!==1&&<TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredCOD}
                </TableCell>}
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredOnAccount}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.DeliveredToPayDDDV}
                </TableCell>

                {selectedFields.hasOwnProperty('DeliveredHamali') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredHamali}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveryOtherHamali') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryOtherHamali}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredInsurance') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredInsurance}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredOtherCharges') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredOtherCharges}
                  </TableCell>
                }
                {selectedFields.hasOwnProperty('DeliveredGST') &&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveredGST}
                  </TableCell>
                }
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ fontSize: '20px', fontWeight: '500', textAlign: 'right' }}
                >
                  {item.TotalDeliveredPayment}
                </TableCell>
                </>
                }
              </>
          }
        </TableRow>
      </>
    )
  }

  const printClick = (isSave) => {
    const widthCell = calculateTotalTableWidth(tableHeader)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const HeaderColumns = pdffilterHeader.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = tableHeader.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: tableHeader.length > 16 ? 'l' : 'p', format: tableHeader.length > 16 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60), unit: 'px', compress: true })
    var pageSize = doc.internal.pageSize
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var pdfFontSize = pageWidth / (tableHeader.length > 16 ? 1122 : 793);
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Quick View Reports.pdf`,
      subject: 'Quick View  Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    let pdfSupHeader = pdfheader.map((val, index) => ({ ...val, colSpan: index === 1 ? tableHeader.length - Math.floor(tableHeader.length / 2) : Math.floor(tableHeader.length / 2) }))
    let pdfHeader = pdfSubHeader.filter((val) => selectedFields.hasOwnProperty(val.field))
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [headerData],
      columnStyles: {
        0: { fontSize: pdfFontSize * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: pdfFontSize * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: pdfFontSize * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: pdfFontSize * 14,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(pdfFontSize * 14).setFont('Roboto', 'bold')
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      head: [pdfSupHeader, pdfHeader],
      headStyles: {
        fillColor: [229, 243, 255],
        fontSize: pdfFontSize * 12,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      columnStyles: generateDynamicColumnStyles(tableHeader, pdfFontSize * 12),
      theme: 'grid',
      willDrawCell: (data) => {
        if (data.row.raw.isTotal) {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(pdfFontSize * 12).setFont("Roboto", 'normal')
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(pdfFontSize * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(pdfFontSize * 20).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Quick View Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(pdfFontSize * 20).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp, pdfFontSize * 14)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Quick View Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('qviewCityWiseOutput').data = pdfUrl
        // document.getElementById('qviewCityWiseOutput').data = doc.output('datauristring', ' Quick View Reports.pdf')
        focusElemnt("backBtn")
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('qviewCityWiseOutput').data = pdfUrl
        // document.getElementById('qviewCityWiseOutput').data = doc.output('datauristring', ' Quick View Reports.pdf')
        focusElemnt("backBtn")
      }, 2000)
    }
  }
  const BookedHeader = ['BookedPaid', 'BookedToPay', 'BookedFOC', 'BookedCOD', 'BookedOnAccount', 'BookedToPayDDDV', 'BookedFreight', 'BookedDocumentCharges', 'BookedHamaliCharges', 'BookedOperatorHamaliChg', 'BookedOtherCharges', 'BookedGST', 'TotalBoookedPayment']
  const matchBookedFields = Object.fromEntries(
    Object.entries(selectedFields).filter(([key]) => BookedHeader.includes(key))
  );
  const DeliveryHeader = ['DeliveredPaid', 'DeliveredToPay', 'DeliveredFOC', 'DeliveredCOD', 'DeliveredOnAccount', 'DeliveredToPayDDDV', 'DeliveredHamali', 'DeliveryOtherHamali', 'DeliveredInsurance', 'DeliveredOtherCharges', 'DeliveredGST', 'TotalDeliveredPayment']
  const matchDeliveryFields = Object.fromEntries(
    Object.entries(selectedFields).filter(([key]) => DeliveryHeader.includes(key))
  );
  return (
    <>
      <Stack style={{ margin: "0px 10px", marginRight: '0px' }}>
        <Item className='userReport'>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Item className='userReport-heading' style={{ color: "#444" }}>
              Report For: Quick View Report
            </Item>
            {SAINI_TRAVELS===intCompanyID?<></>:
            <Box
              sx={{
                minHeight: '32px',
                display: 'flex',
                padding: '8px 12px',
                justifycontent: 'center',
                alignitems: 'center',
                gap: '6px',
                marginX: '10px',
                fontSize: '14px'
              }}
              id="dispatchReportManageColumn"
              tabIndex={0}
              onClick={() => updateModal(true, mdt.manageColQuickView)}
            >
              <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                <AppsIcon />
              </span>
              <span tabIndex={0} style={{ fontWeight: '600' }}>
                MANAGE COLUMNS
              </span>
            </Box>
            }
          </Box>
          <Item className='userReport-buttons'>
            {searchResult ? <>
              {disableExcel ?
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" disabled={true}>Export to Excel</Button>
                </Box>
                :
                <Box onKeyDown={(e) => navigation3(e, "ExportToPdf", "SplitButton", () => { })}>
                  <ReactHtmlTableToExcel
                    id="ExportToExl"
                    className="userWisereporttemExcelBtn"
                    table="table-quikViewBranchReport-xls"
                    filename={`Quik View Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Box>}
                {SAINI_TRAVELS===intCompanyID?<></>:
                <>
              <Box>
                <Button variant="outlined" className="userWisereporttembtn" id="ExportToPdf"
                  onClick={() => {
                    setSearchResult(false);
                    printClick(true)
                  }}
                  onKeyDown={(e) => navigation3(e, "PrintBtn", disableExcel ? "SplitButton" : "ExportToExl", () => { setSearchResult(false); printClick(true) })}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined" id="PrintBtn"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setSearchResult(false);
                    printClick(false)
                  }}
                  onKeyDown={(e) => navigation3(e, id.fromDate, "ExportToPdf", () => { setSearchResult(true); printClick(false) })}
                >
                  Print
                </Button>
              </Box>
              </>}
            </> : <>
              <Box>
                <Button
                  variant="outlined" id="backBtn"
                  className="userWisereporttembtn"
                  onClick={() => setSearchResult(true)}
                  onKeyDown={(e) => navigation3(e, id.fromDate, "SplitButton", () => { setSearchResult(true); focusElemnt("SplitButton") })}
                >
                  Back
                </Button>
              </Box>
            </>}

          </Item>
        </Item>
      </Stack>
      {
        searchResult ?
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 540 }} >
            <TableContainer style={{ border: '1px solid #e0e0e0', borderRadius: '12px' }} className="scroll">
              <Table stickyHeader className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ position: 'sticky', top: "0" }}>
                  {SAINI_TRAVELS===intCompanyID?<></>:
                  <TableRow >
                    <TableCell
                      style={{
                        backgroundColor: '#DAEDFE',
                        color: '#444444',
                        fontSize: '12px',
                        fontWeight: '500',
                        textAlign: 'center',
                        borderRight: "1px solid #e0e0e0"
                      }}
                      colSpan={2}
                    >

                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#DAEDFE',
                        color: '#444444',
                        fontSize: '12px',
                        fontWeight: '500',
                        textAlign: 'center',
                        borderRight: "1px solid #e0e0e0",
                      }}
                      colSpan={Object.keys(matchBookedFields).length}
                    >
                      Booked
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#DAEDFE',
                        color: '#444444',
                        fontSize: '12px',
                        fontWeight: '500',
                        textAlign: 'center',
                      }}
                      colSpan={Object.keys(matchDeliveryFields).length}
                    >
                      Delivery
                    </TableCell>
                  </TableRow>
                  }
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444444',
                        fontSize: '12px',
                        fontWeight: '500',
                        textAlign: 'left',
                        minWidth: "100px",
                        whiteSpace: "pre-line"
                      }}
                      colSpan={1}
                    // rowSpan={2}
                    >
                      {`City\nName`}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#454646',
                        fontSize: '12px',
                        fontWeight: '500',
                        textAlign: 'left',
                        borderRight: "1px solid #e0e0e0",
                        minWidth: "150px",
                        whiteSpace: "pre-line"
                      }}
                      colSpan={1}
                    // rowSpan={2}
                    >
                      {`Branch\nName`}
                    </TableCell>
                    {
                      tableHeader?.map((val, i) =>
                        !["CityName", "BranchName"]?.includes(val.field) ? <TableCell
                          style={{
                            backgroundColor: '#e5f3ff',
                            color: '#454646',
                            fontSize: '12px',
                            fontWeight: '500',
                            textAlign: 'right',
                            borderRight: i === Object.keys(matchBookedFields).length + 1 ? "1px solid #e0e0e0" : ""
                          }}
                          colSpan={1}
                        >
                          {val.header}
                        </TableCell> : null
                      )
                    }
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={tableHeader.length}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500', marginLeft: '5px' }}
                  >
                    {tableData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} UseToPayAsCOD={UseToPayAsCOD} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table sx={{ marginRight: 2, paddingTop: '10px' }} id="table-quikViewBranchReport-xls" style={{ display: "none" }} aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={Math.floor(tableHeader.length / 2)}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Quick View Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={tableHeader.length - Math.floor(tableHeader.length / 2)}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={tableHeader.length}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {pdffilterHeader?.map((item, i) =>
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: "#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                        colSpan={i === 2 ? tableHeader.length - Math.floor(tableHeader.length / 3) * 2 : Math.floor(tableHeader.length / 3)}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    )}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ color: "#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={Math.floor(tableHeader.length / 3)}
                    >
                      {moment(headerData.fromDate).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ color: "#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={Math.floor(tableHeader.length / 3)}
                    >
                      {moment(headerData.toDate).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ color: "#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={tableHeader.length - Math.floor(tableHeader.length / 3) * 2}
                    >
                      {headerData.selectedOption}
                    </TableCell>

                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={tableHeader.length}></TableCell>
                  </TableRow>
                </TableHead>
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  {SAINI_TRAVELS===intCompanyID?<></>:
                  <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                    <TableCell className="userWiseReportHeading" style={{ textAlign: "center", color: "#444444", fontSize: '20px', backgroundColor: "#BFE1FF", }} colSpan={Math.floor(tableHeader.length / 2)}>Booked</TableCell>
                    <TableCell className="userWiseReportHeading" style={{ textAlign: "center", color: "#444444", fontSize: '20px', backgroundColor: "#BFE1FF", }} colSpan={tableHeader.length - Math.floor(tableHeader.length / 2)}>Delivery</TableCell>
                  </TableRow>
                  }
                  <TableRow className='sammary-heading' style={{ borderRadius: "10px 10px 10px 10px" }}>
                    {tableHeader?.map((item, i) =>
                      <TableCell className="userWiseReportHeading" key={i} style={{ textAlign: item.align, color: "#444444", fontSize: '20px', backgroundColor: "#DAEDFE", }} colSpan={1}>{item?.header}</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={tableHeader.length}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500', marginLeft: '5px' }}
                  >
                    {tableData?.map((item, index) => (
                      <InsideRowContentForExcel item={item} index={index} key={index} UseToPayAsCOD={UseToPayAsCOD}/>
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
          : <>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <object
                id="qviewCityWiseOutput"
                type="application/pdf"
                width={"100%"}
                height="440"
                title="MTLPL -Cargo System - Quick View Report"
                aria-label="MTLPL -Cargo System - Quick View Report"
              ></object>
            ) : (
              ''
            )}
          </>
      }

    </>
  )
}

export default QuickViewCitywiseBranchwise
